import { FrameContext } from '@tribeplatform/react-ui-kit/Frame'

import { Navbar } from './Navbar.js'

export const NavbarPreview = props => {
  return (
    <FrameContext.Provider
      value={{
        fullWidth: false,
      }}
    >
      <Navbar {...props} />
    </FrameContext.Provider>
  )
}
